<div class="modal-header border-0 py-3">
    <div class="d-flex flex-column w-100">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <i class="fas fa-envelope text-primary me-2"></i>
                <h5 class="modal-title mb-0">Email Logs</h5>
            </div>
            <div class="d-flex align-items-center">
                <div class="search-box me-3" *ngIf="!customerId">
                    <input type="text" 
                           class="form-control form-control-sm" 
                           placeholder="Search..." 
                           [(ngModel)]="searchTerm"
                           (keyup.enter)="onSearch()">
                </div>
                <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
            </div>
        </div>
        <span class="text-muted mt-1 small">{{ totalRecords }} logs found</span>
    </div>
</div>

<div class="modal-body p-0 custom-scrollbar">
    <!-- Loading Spinner -->
    <div class="text-center py-5" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted">Loading email logs...</p>
    </div>

    <!-- No Records Message -->
    <div class="text-center py-5" *ngIf="!isLoading && emailLogs.length === 0">
        <i class="fas fa-inbox text-muted fa-3x mb-3"></i>
        <p class="text-muted mb-0">No email logs found</p>
    </div>

    <!-- Email Logs Table -->
    <div class="table-container" *ngIf="!isLoading && emailLogs.length > 0">
        <table class="table table-hover mb-0">
            <thead>
                <tr>
                    <th class="ps-4" style="width: 40px">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="selectAll" 
                                   [checked]="allSelected"
                                   (change)="toggleSelectAll()">
                        </div>
                    </th>
                    <th class="text-nowrap">Name</th>
                    <th class="text-nowrap">Email</th>
                    <th class="text-nowrap">User ID</th>
                    <th class="text-nowrap">Template</th>
                    <th class="text-nowrap">Created Date</th>
                    <th class="text-nowrap">Status</th>
                    <th class="text-nowrap">Type</th>
                    <th class="text-nowrap">Preview</th>
                    <th class="text-nowrap">Dynamic Data</th>
                    <th class="text-nowrap pe-4">Day</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let log of emailLogs">
                    <td class="ps-4">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" 
                                   [id]="'log-' + log.id"
                                   [checked]="isSelected(log.id)"
                                   (change)="toggleSelectLog(log.id)">
                        </div>
                    </td>
                    <td>{{ getRecipientName(log) }}</td>
                    <td class="email-cell">{{ log.Email }}</td>
                    <td>{{ log.UserId }}</td>
                    <td>{{ log.TemplateIdentifier }}</td>
                    <td>{{ log.CreatedDate | date:'MMM dd, yyyy, h:mm a' }}</td>
                    <td>
                        <span class="badge" [ngClass]="{
                            'badge-success': log.Status === 'Sent',
                            'badge-warning': log.Status === 'Pending',
                            'badge-danger': log.Status === 'Failed'
                        }">{{ log.Status }}</span>
                    </td>
                    <td>
                        <span class="badge" [ngClass]="{
                            'badge-warning': log.Type === 'Pending Documents',
                            'badge-danger': log.Type === 'Abandoned Application',
                            'badge-info': log.Type !== 'Pending Documents' && log.Type !== 'Abandoned Application'
                        }">{{ log.Type }}</span>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-sm btn-primary" 
                                (click)="showMandrillPreview(log.MessageId)"
                                [disabled]="!log.MessageId">
                            Show
                        </button>
                    </td>
                    <td class="text-center">
                        <i class="fas fa-info-circle text-muted cursor-pointer" 
                           style="font-size: 1.1rem;" 
                           (click)="showDynamicData(log)" 
                           title="View Dynamic Data"></i>
                    </td>
                    <td class="pe-4">
                        <span class="badge badge-info">Day {{ log.Day }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <div class="border-top" *ngIf="!isLoading && emailLogs.length > 0">
        <nav class="d-flex justify-content-between align-items-center p-3">
            <div class="text-muted small">
                Showing {{ (currentPage - 1) * perPage + 1 }} to {{ Math.min(currentPage * perPage, totalRecords) }} of {{ totalRecords }} entries
            </div>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item" *ngFor="let link of paginationLinks" 
                    [class.active]="link.active" 
                    [class.disabled]="!link.url">
                    <a class="page-link" href="javascript:void(0)" 
                       (click)="onPageChange(link.url)" 
                       [innerHTML]="link.label"></a>
                </li>
            </ul>
        </nav>
    </div>
</div>

<!-- Mandrill Email Preview Modal -->
<div class="modal fade mandrill-preview-modal" id="mandrillPreviewModal" tabindex="-1" aria-labelledby="mandrillPreviewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered mandrill-modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="mandrillPreviewModalLabel"> Email Preview</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="mandrillLoading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading email preview...</p>
                </div>
                
                <div *ngIf="!mandrillLoading && mandrillEmailContent" [innerHTML]="mandrillEmailContent" class="email-content-direct"></div>
                
                <div *ngIf="!mandrillLoading && mandrillError" class="alert alert-danger d-flex align-items-center">
                    <i class="fas fa-exclamation-triangle me-3 fs-4"></i>
                    <div>
                        <strong>Error:</strong> {{ mandrillError }}
                    </div>
                </div>
                
                <div *ngIf="!mandrillLoading && !mandrillEmailContent && !mandrillError" class="text-center py-5">
                    <i class="fas fa-inbox fs-1 text-muted mb-3"></i>
                    <p class="text-muted">No email content available</p>
                </div>
            </div>

        </div>
    </div>
</div>

<style>
.table-container {
    background-color: #fff;
}

.table {
    margin-bottom: 0;
}

.table thead {
    background-color: #f8f9fa;
}

.table th {
    font-weight: 500;
    color: #495057;
    font-size: 0.875rem;
    border-bottom: 1px solid #e9ecef;
    padding: 0.75rem;
}

.table td {
    padding: 0.75rem;
    vertical-align: middle;
    color: #495057;
    font-size: 0.875rem;
    border-bottom: 1px solid #f1f3f5;
}

.table tr:hover {
    background-color: #f8f9fa;
}

.form-check {
    margin: 0;
}

.form-check-input {
    cursor: pointer;
}

.status-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
}

.status-sent {
    background-color: #e6f4ea;
    color: #1e7e34;
}

.status-pending {
    background-color: #fff3cd;
    color: #856404;
}

.status-failed {
    background-color: #f8d7da;
    color: #dc3545;
}

.type-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
    background-color: #e7f5ff;
    color: #1971c2;
}

.type-badge.pending-documents {
    background-color: #e7f5ff;
    color: #1971c2;
}

.type-badge.abandoned-application {
    background-color: #fff0f6;
    color: #e64980;
}

.day-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
    background-color: #f3f0ff;
    color: #7048e8;
}

.text-primary {
    color: #007bff !important;
}

.modal-body:not(#mandrillPreviewModal .modal-body) {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
}

.pagination {
    margin-bottom: 0;
}

.page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    color: #495057;
}

.page-item.active .page-link {
    background-color: #007bff;
    border-color: #007bff;
}

@media (max-width: 768px) {
    .table {
        font-size: 0.875rem;
    }
    
    .status-badge,
    .type-badge,
    .day-badge {
        padding: 0.2rem 0.5rem;
        font-size: 0.7rem;
    }
}

/* Custom scrollbar styles */
.custom-scrollbar {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
}

.custom-scrollbar::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
}

/* General modal header styles (not affecting Mandrill modal) */
.modal-header:not(#mandrillPreviewModal .modal-header) {
    background-color: #fff;
    border-bottom: 1px solid #f1f3f5 !important;
}

.modal-title:not(#mandrillPreviewModal .modal-title) {
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
}

.cursor-pointer {
    cursor: pointer;
}

.search-box {
    width: 250px;
}

.search-box input {
    border-radius: 4px;
    border: 1px solid #dee2e6;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
}

.search-box input:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
    outline: 0;
}

/* Simple nested modal fix - only z-index */
.mandrill-preview-modal {
    z-index: 1070 !important;
}

/* Clean slate - no complex rules */

.mandrill-preview-modal .modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 
        0 20px 25px -5px rgba(0, 0, 0, 0.15),
        0 10px 10px -5px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
}

.mandrill-preview-modal .modal-body {
    flex: 1;
    overflow-y: auto;
    max-height: calc(90vh - 120px); /* Account for header and footer */
}

.mandrill-preview-modal .modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: none;
    padding: 1.5rem;
    flex-shrink: 0;
}

.mandrill-preview-modal .modal-title {
    color: white;
    font-weight: 600;
    font-size: 1.25rem;
}

.mandrill-preview-modal .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.8;
}

.mandrill-preview-modal .btn-close:hover {
    opacity: 1;
}

.mandrill-preview-modal .modal-footer {
    background-color: #fff;
    border-top: 1px solid #e9ecef;
    padding: 1rem 2rem;
    flex-shrink: 0;
}

/* Mandrill Email Preview Modal Styles */
.email-content-direct {
    background-color: white;
    padding: 0;
    margin: 0;
    min-height: 200px;
    max-height: 70vh;
    overflow-y: auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
    /* Hide scrollbar but keep functionality */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
}

.email-content-direct::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

.email-content-direct img {
    max-width: 100%;
    height: auto;
}

.email-content-direct table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0;
}

.email-content-direct td, .email-content-direct th {
    padding: 8px;
    text-align: left;
}

.email-content-direct pre {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 4px;
    border-left: 4px solid #007bff;
    overflow-x: auto;
    font-size: 0.9em;
}

.email-content-direct h1, .email-content-direct h2, .email-content-direct h3, 
.email-content-direct h4, .email-content-direct h5, .email-content-direct h6 {
    color: #2c3e50;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}

.email-content-direct a {
    color: #007bff;
    text-decoration: none;
}

.email-content-direct a:hover {
    text-decoration: underline;
}


</style> 